<script>
  import loginServico from './servico';

  export default {
    data() {
      return {
        usuario: {},
        mostrarErroUsuario: false, 
        acompanhamentoPendente: false,
        relatorioTecnicoPendente: false,
        senhaExpirada: false,
        exibirNotificacao: false,
        mensagemErroUsuario: "CPF ou senha incorreto(s).",
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      validar: function () {
        this.$validator.validateAll();

        if (!this.errors.any()) {
          this.login()
        }
      },
      mostrarMensagemInicialWeb() {        
        if (!this.configuracao.mensagemInicialWeb) return;

        this.$swal({
          title: 'Comunicado',
          html: this.configuracao.mensagemInicialWeb.replace(/\r\n/g, '<br>'),
          type: 'info',
          confirmButtonText: 'Ok, entendi!',
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      },
      login: function () {
        this.mostrarErroUsuario = false;
        
        $('.btn').button('loading');

        loginServico.coordenador(this.usuario)
          .then(resposta => {
            this.$storage.usuario(resposta.body.usuario);
            this.$storage.token(resposta.body.token);
            this.$storage.termoLGPD(!this.configuracao.lgpdAvisoGeral);
            this.acompanhamentoPendente = resposta.body.usuario.acompanhamentoPendente;
            this.relatorioTecnicoPendente = resposta.body.usuario.relatorioTecnicoPendente;
            this.senhaExpirada = resposta.body.usuario.senhaExpirada;
            this.exibirNotificacao = resposta.body.usuario.exibirNotificacao;
          })
          .then(() => {
            if (this.acompanhamentoPendente) {
              this.$router.push({ name: 'acompanhamento-projeto' });
            }
            else {
              if (this.relatorioTecnicoPendente) {
                this.$router.push({ name: 'relatorio-tecnico-projeto' });
              }
              else {
                if (this.senhaExpirada) {
                  this.$router.push({ name: 'alterar-senha' });
                }
                else {
                  if (this.exibirNotificacao) {
                    this.$router.push({ name: 'notificacoes' });
                  }
                  else
                    this.$router.push('/');
                }
              }
            }

            this.mostrarMensagemInicialWeb();
          })
          .catch(erro => {
            $('.btn').button('reset');
            
            if (erro.status === 404) {
              this.mostrarErroUsuario = true;
            } else {
              if (erro.status === 422) {
                this.mensagemErroUsuario = erro.bodyText; 
                this.mostrarErroUsuario = true;
              } else{
                this.$swal('', 'Ocorreu um erro no login, caso o erro persista entre em contato com a fundação.', 'error');
              }
            }
          });
      }
    },
    computed: {
      mostrarLinkExterno() {
        return this.configuracao.textoLinkExterno && this.configuracao.enderecoLinkExterno;
      }
    }
  }
</script>

<template>
  <div>
    <form class="m-t" role="form" @submit.prevent="validar">
      <div class="alert alert-danger" role="alert" v-show="mostrarErroUsuario">{{ mensagemErroUsuario }}</div>

      <div class="form-group" :class="{ 'has-error': errors.has('CPF') }">
        <input type="text"
               class="form-control"
               placeholder="CPF"
               name="CPF"
               id="cpf"
               v-model="usuario.login"
               v-validate="'required'"
               v-mascara="'cpf'">

        <p class="text-danger" v-if="errors.has('CPF')">{{ errors.first('CPF') }}</p>
      </div>
      <div class="form-group" :class="{ 'has-error': errors.has('senha') }">
        <input type="password"
               class="form-control"
               placeholder="*******"
               name="senha"
               v-model="usuario.senha"
               v-validate="'required'">

        <p class="text-danger" v-if="errors.has('senha')">{{ errors.first('senha') }}</p>
      </div>
      <button type="submit"
              class="btn btn-primary block full-width m-b"
              data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Entrando...">
        Entrar
      </button>

      <router-link to="/recuperar-senha" class="text-info">
        <i class="fa fa-lock"></i> RECUPERAR SENHA
      </router-link>

      <router-link to="/login/funcionario" class="text-info">
        <i class="fa fa-external-link"></i> ACESSAR COMO FUNCIONÁRIO
      </router-link>
    </form>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/login/Login.vue